import {
    GET_BRANCHES,
    GET_BRANCHES_SUCCESS,
    GET_BRANCHES_FAILED,

    SUBMIT_BRANCH_FORM,
    SUBMIT_BRANCH_FORM_SUCCESS,
    SUBMIT_BRANCH_FORM_FAILED,

    DELETE_BRANCH,
    DELETE_BRANCH_SUCCESS,
    DELETE_BRANCH_FAILED
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    branches: [],
    submittingForm: false,
    error: null,
    deleting: false
};

const BranchReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BRANCHES:
            return { ...state, loading: true };
        case GET_BRANCHES_SUCCESS:
            return { ...state, branches: action.payload.data, total: action.payload.total, loading: false, error: null };
        case GET_BRANCHES_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_BRANCH_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_BRANCH_FORM_SUCCESS:
            const alreadyExists = state.branches.find((branch) => branch.id === action.payload.id);
            let branches;
            let total = state.total;
            if (!alreadyExists) {
                branches = [action.payload, ...state.branches];
                total += 1;
            } else {
                branches = state.branches.map((branch) => {
                if (branch.id === action.payload.id) {
                  return action.payload;
                }
                return branch;
              });
            }
            return { ...state, total,  branches: branches, submittingForm: false };
        case SUBMIT_BRANCH_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_BRANCH:
            return { ...state, error: null, deleting: true };
        case DELETE_BRANCH_SUCCESS:
            return { ...state, total: state.total - 1, branches: state.branches.filter(branch => branch.id !== action.payload) , deleting: false };
        case DELETE_BRANCH_FAILED:
            return { ...state, error: action.payload, deleting: false };
        default: return { ...state };
    }
}

export default BranchReducer;